import { Icon } from '@chakra-ui/react';
import { MdArrowUpward, MdArrowDownward } from 'react-icons/md';
import type { SortDirection } from '@tanstack/react-table';

/**
 * Render a sort direction arrow next to a table header.
 * Returns null when the column is not sorted.
 *
 * Usage inside a TanStack Table header:
 *   {flexRender(header.column.columnDef.header, header.getContext())}
 *   <SortIndicator direction={header.column.getIsSorted()} />
 */
export default function SortIndicator({ direction }: { direction: false | SortDirection }) {
    if (!direction) return null;

    return (
        <Icon
            as={direction === 'asc' ? MdArrowUpward : MdArrowDownward}
            w='12px'
            h='12px'
            ml='4px'
            color='brand.500'
            flexShrink={0}
        />
    );
}
